import { FREE_SUB_PACKAGE_TYPES, SUB_PACKAGE_STATUS, SUB_PACKAGE_STATUS_NAME } from '../config/constants';

type SubscriptionPayload = Record<string, any>;
type UserRecord = Record<string, any>;

/** Merges subscription API response into a user object (pure; does not persist). */
export const applySubscriptionToUser = (
    baseUser: UserRecord | null | undefined,
    subscription: SubscriptionPayload
): UserRecord => {
    const user = { ...(baseUser || {}) };

    user.subscriptionGUID = [];
    user.subscriptionStatus = [];
    user.tierConfig = [];
    user.tierStatus = [];
    user.tvodList = [];
    user.ppvList = [];

    const { subRev, subList, tier, tierStatus, tvodList, identityToken, ppvList } = subscription;

    if (typeof subRev !== 'undefined' && subRev !== null) {
        user.subscriptionRev = subRev;
    }

    if (typeof subList !== 'undefined' && subList !== null) {
        user.subscriptionStatus = subList.map((sub: Record<string, any>) => {
            const normalized = { ...sub };

            if (
                Object.prototype.hasOwnProperty.call(normalized, 'subPackageType') &&
                (normalized.subPackageType.toLowerCase() === FREE_SUB_PACKAGE_TYPES.alacart_free.toLocaleLowerCase() ||
                    normalized.subPackageType.toLowerCase() === FREE_SUB_PACKAGE_TYPES.add_on_free.toLocaleLowerCase())
            ) {
                normalized.status = SUB_PACKAGE_STATUS.active;
            } else {
                normalized.status =
                    Object.prototype.hasOwnProperty.call(normalized, 'status') &&
                    typeof normalized.status !== 'undefined' &&
                    normalized.status
                        ? SUB_PACKAGE_STATUS.active
                        : SUB_PACKAGE_STATUS.inactive;
            }

            normalized.statusName =
                Object.prototype.hasOwnProperty.call(normalized, 'statusName') &&
                typeof normalized.statusName !== 'undefined'
                    ? normalized.statusName
                    : SUB_PACKAGE_STATUS_NAME.active;

            if (
                !Object.prototype.hasOwnProperty.call(normalized, 'billingCycle') ||
                typeof normalized.billingCycle === 'undefined' ||
                normalized.billingCycle === null
            ) {
                normalized.billingCycle = 0;
            }
            if (typeof normalized.nextRenewalDate !== 'undefined') {
                normalized.nextRenewalDate *= 1000;
            }
            if (typeof normalized.subscriptionDate !== 'undefined') {
                normalized.subscriptionDate *= 1000;
            }
            if (typeof normalized.lastUpdated !== 'undefined') {
                normalized.lastUpdated *= 1000;
            }

            return normalized;
        });

        user.subscriptionGUID = user.subscriptionStatus.map((sub: Record<string, any>) => sub.subscriptionGuid);
    }

    if (typeof tier !== 'undefined' && tier !== null) {
        user.tierConfig = tier;
    }
    if (typeof tierStatus !== 'undefined' && tierStatus !== null) {
        user.tierStatus = tierStatus;
    }
    if (typeof tvodList !== 'undefined' && tvodList !== null) {
        user.tvodList = tvodList;
    }
    if (typeof identityToken !== 'undefined' && identityToken !== null) {
        user.identityToken = identityToken;
    }
    if (typeof ppvList !== 'undefined' && ppvList !== null) {
        user.ppvList = ppvList;
    }

    return user;
};
